import merge from 'lodash/merge'
import units from '@/data/units.json'
import models from '@/data/models.json'
import { UNIT_STATUS } from '@/modules/useUnit'

export default {
  namespaced: true,
  state: () => ({
    units: [],
  }),
  mutations: {
    set (state, payload) {
      payload.forEach(p => {
        if (p.UnitNumber === '0042') {
          p.ModelID = 'H3171001'
        }

        p.model = models.find(m => m.id === p.ModelID)
      })
      state.units = merge(units, payload)
    },
  },
  getters: {
    available (state) {
      return state.units.filter(unit => UNIT_STATUS.STATUS_AVAILABLE.includes(unit.UnitStatus))
    },
    sold (state) {
      return state.units.filter(unit => UNIT_STATUS.STATUS_SOLD.includes(unit.UnitStatus))
    },
    hold (state) {
      return state.units.filter(unit => UNIT_STATUS.STATUS_HOLD.includes(unit.UnitStatus))
    },
  },
}
